// Feature flag pour l'intégration Qonto.
//
// Partenariat Qonto abandonné définitivement (compte bancaire payant
// ≥ 11€/mois pour les abonnés, contraire au positionnement "zéro surcoût"
// de Biz360). Désactivé partout, sans dépendre du domaine ni d'une
// variable d'environnement, pour éviter tout affichage accidentel en prod.
//
// Côté backend, une protection 503 supplémentaire existe sur /api/qonto/*
// (défense en profondeur, indépendante du client).

export const QONTO_ENABLED = false;